var songUrl = "/music-library/songs/";
var imageUrl = "/music-library/images/";

export const SONGS = [
  {
    name: "Blinding Lights",
    img: `${imageUrl}BlindingLights.jpg`,
    src: `${songUrl}BlindingLights.mp3`,
    singer: "Weeknd",
  },
  {
    name: "Despacito",
    img: `${imageUrl}Despacito.jpg`,
    src: `${songUrl}Despacito.mp3`,
    singer: "Luis Fonsi",
  },
  {
    name: "Memories",
    img: `${imageUrl}Memories.jpg`,
    src: `${songUrl}Memories.mp3`,
    singer: "Maroon 5",
  },
  {
    name: "Bad Guy",
    img: `${imageUrl}Badguy.jpg`,
    src: `${songUrl}Badguy.mp3`,
    singer: "Billie Eilish",
  },
  {
    name: "Starboy",
    img: `${imageUrl}Starboy.jpg`,
    src: `${songUrl}Starboy.mp3`,
    singer: "Weeknd",
  },
  {
    name: "Afterglow",
    img: `${imageUrl}Afterglow.jpg`,
    src: `${songUrl}Afterglow.mp3`,
    singer: "Ed Sheeran",
  },
  {
    name: "Don't Start Now",
    img: `${imageUrl}DontStartNow.jpg`,
    src: `${songUrl}DontStartNow.mp3`,
    singer: "Dua Lipa",
  },
  {
    name: "Aftershock (Remix)",
    img: `${imageUrl}Aftershock.jpg`,
    src: `${songUrl}Aftershock.mp3`,
    singer: "Cash Cash",
  },
  {
    name: "We Don't Talk Anymore",
    img: `${imageUrl}WeDontTalkAnymore.jpg`,
    src: `${songUrl}WeDontTalkAnymore.mp3`,
    singer: "Selena Gomez",
  },
  {
    name: "Shape Of You",
    img: `${imageUrl}ShapeOfYou.jpg`,
    src: `${songUrl}ShapeOfYou.mp3`,
    singer: "Ed Sheeran",
  },
];
